<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button size="small" icon="el-icon-plus" class="search-btn btn-primary" @click="gotoDetails(0)" v-if="permission.add">{{ permission.add }}</el-button>
                <el-button v-if="permission.print" size="small" icon="el-icon-printer" class="search-btn btn-primary" @click="print()">{{ permission.print }}</el-button>
                <el-button v-if="permission.printEng" size="small" icon="el-icon-printer" class="search-btn btn-primary" @click="printEng()">{{ permission.printEng }}</el-button>
                <el-button v-if="permission.export" size="small" icon="el-icon-download" class="search-btn btn-primary" @click="exportForm()">{{ permission.export }}</el-button>
                <el-button v-if="permission.exportEng" size="small" icon="el-icon-download" class="search-btn btn-primary" @click="exportEngForm()">{{
                    permission.exportEng
                }}</el-button>
            </div>
            <div class="search-ctn-right">
                <div class="search-name">客户</div>
                <el-select
                    class="search-item"
                    size="small"
                    v-model="searchData.EntpCusName"
                    remote
                    filterable
                    allow-create
                    placeholder="客户名称/电话"
                    :remote-method="searchCustom"
                    v-select-scroll-more="searchCustomLoad"
                    popper-class="my-select"
                >
                    <el-option v-for="item in cusOptions" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusName"> </el-option>
                </el-select>
                <div class="search-name">装箱单号</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.Code" v-filter-special-char="searchData.Code" placeholder="请输入装箱单号"></el-input>
                <div class="search-name">销售单号</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.OrderCode" v-filter-special-char="searchData.OrderCode" placeholder="请输入销售单号"></el-input>
                <div class="search-name">状态</div>
                <el-select class="search-item" size="small" v-model="searchData.State">
                    <el-option v-for="item in StateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                </el-select>
                <div class="search-name">装箱员</div>
                <el-select v-model="searchData.SId" class="search-item" filterable clearable remote size="small" placeholder="请选择" @visible-change="siVisibleChange($event)">
                    <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                </el-select>
                <div class="search-name">更新时间</div>
                <i class="el-icon-date search-name time-btn" @click="timeVisible = true"></i>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
            </div>
        </div>
        <div class="table-ctn pack-order">
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                :data="tableData"
                ref="multipleTable"
                @selection-change="handleSelectionChange"
                style="width: 100%"
                @cell-dblclick="handleDBClick"
                border
            >
                <el-table-column type="selection"></el-table-column>
                <el-table-column show-overflow-tooltip label="装箱单号" width="210px">
                    <template slot-scope="scope">
                        <el-badge :value="'打印' + scope.row.PrintedCount + '次'" class="mark" type="danger" v-if="scope.row.PrintedCount > 0">
                            {{ scope.row.PackingCode }}
                        </el-badge>
                        {{ scope.row.PrintedCount > 0 ? '' : scope.row.PackingCode }}
                    </template></el-table-column
                >
                <el-table-column show-overflow-tooltip prop="OrderCode" label="关联销售单号" width="180px">
                    <template slot-scope="scope">
                        <div class="ordercodediv">
                            <el-tag class="codetag" v-for="(item, index) in scope.row.OrderList" :key="index" @click="gotoSalesDetails(item.EntpCusOId)">{{
                                item.OrderCode
                            }}</el-tag>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="EntpCusName" label="客户" show-overflow-tooltip></el-table-column>
                <el-table-column prop="BoxCount" label="总箱数" show-overflow-tooltip width="100px"></el-table-column>
                <el-table-column label="总体积（m³）" show-overflow-tooltip width="110px">
                    <template slot-scope="scope">{{ scope.row.VolumeCount.toFixed(3) }}</template>
                </el-table-column>
                <el-table-column label="总重量（kg）" show-overflow-tooltip width="110px">
                    <template slot-scope="scope">{{ scope.row.WeightCount.toFixed(3) }}</template>
                </el-table-column>
                <el-table-column width="120px" prop="StateName" label="状态" show-overflow-tooltip></el-table-column>
                <el-table-column prop="SName" label="装箱员" show-overflow-tooltip width="100px"></el-table-column>
                <el-table-column width="180px" prop="UpdateTime" label="更新时间" show-overflow-tooltip></el-table-column>
                <el-table-column prop="Remark" label="备注" show-overflow-tooltip></el-table-column>
                <el-table-column label="操作" fixed="right" :autoWidth="true">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button v-if="permission.edit && scope.row.StateName == '未提交'" @click="gotoDetails(2, scope.row)" type="text" size="small">{{
                                permission.edit
                            }}</el-button>
                            <el-button v-if="permission.submit && scope.row.StateName == '未提交'" @click="submit(scope.row)" type="text" size="small">{{
                                permission.submit
                            }}</el-button>
                            <el-button v-if="permission.del && scope.row.StateName == '未提交'" @click="del(scope.row)" type="text" size="small" style="color: red">{{
                                permission.del
                            }}</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
        <!--  打印  -->
        <el-dialog :close-on-click-modal="false" title="打印" :visible.sync="dialogVisible" width="870px">
            <div class="dialog-content" v-if="dialogVisible">
                <printContent @closeDialog="closeDialog" :printIds="idList"></printContent>
            </div>
        </el-dialog>
        <!--  打印英文版  -->
        <el-dialog :close-on-click-modal="false" title="打印英文装箱单" :visible.sync="dialogPrintEngVisible" width="870px">
            <div class="dialog-content" v-if="dialogPrintEngVisible">
                <printEngContent @closeDialog="closePrintEngDialog" :printIds="idList"></printEngContent>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="创建时间" :visible.sync="timeVisible" width="800px">
            <div class="dialog-content" v-if="timeVisible">
                <timePicker @timerSearch="timerSearch" :start="this.searchData.StartDate" :end="this.searchData.EndDate"></timePicker>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import mixin from '@/mixins/mixin';
import printContent from '@/components/business/goods/printPackingList';
import printEngContent from '@/components/business/goods/printPackingListEng';
import timePicker from '@/components/common/timePicker';
import breadcrumb from '@/components/common/breadcrumb';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    name: '',
    components: {
        timePicker,
        printContent,
        printEngContent,
        breadcrumb,
        elTableColumn
    },
    data() {
        return {
            timeVisible: false,
            multipleSelection: null,
            dialogVisible: false,
            dialogPrintEngVisible: false,
            tableData: [],
            options: [],
            idList: [],
            searchData: {
                EntpCusName: '',
                Code: '',
                SId: '',
                OrderCode: '',
                StartDate: '',
                EndDate: '',
                page: 1, // 当前页数
                limit: 15 // 每页限制条数
            },
            tableDataLength: 0,
            permission: {},
            StateList: [
                { Text: '全部', Value: '' },
                { Text: '未提交', Value: '0' },
                { Text: '已提交', Value: '1' }
            ],
            SIdList: [],
            // 用于客户名称列表，分页搜索
            cusOptions: [],
            cusForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            }
        };
    },
    activated() {
        if (this.$store.state.needRefresh) {
            this.$store.commit('updateNeedRefresh', false);
            this.getTableData();
        }
    },
    mounted() {
        this.getTableData();
        this.searchCustom();
        this.permission = this.$util.getPermission('PackingList');
        this.$util.setEnterEvent(this, this.$route.fullPath);
    },
    methods: {
        // 客户名称列表，搜索
        async searchCustom(key) {
            if (![undefined].includes(key)) {
                this.cusForm.Page = 1;
                this.cusForm.stopLoad = false;
                this.cusForm.key = key;
                this.cusOptions = [];
            }
            if (this.cusForm.stopLoad) return;
            const data = await this.$util.searchCustomerNoAuth(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit);
            if (data) {
                if (!data) return;
                this.cusForm.stopLoad = data.length < this.cusForm.Limit;
                this.cusOptions = [...this.cusOptions, ...data];
            }
        },
        // 客户名称列表，加载更多
        searchCustomLoad() {
            this.cusForm.Page += 1;
            this.searchCustom();
        },
        timerSearch(timer) {
            this.timeVisible = false;
            this.searchData.StartDate = timer.start;
            this.searchData.EndDate = timer.end;
            this.handleSearch();
        },
        getSIdList() {
            this.$util.getSIdList().then(data => {
                this.SIdList = data;
            });
        },
        submit(row) {
            let that = this;
            this.$util.elConfirm({
                content: '确定要提交该装箱单吗？',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosPost({
                            url: '/api/EntpPackingList/SubmitEnterprisePackingList',
                            data: {
                                Id: row.Id
                            }
                        })
                        .then(() => {
                            that.$util.successMsg('提交成功');
                            that.getTableData();
                        });
                }
            });
        },
        // 跳转到销售单详情
        gotoSalesDetails(oid) {
            this.$router.push(`/salesManage/salesOrder/edit_v2?type=1&id=${oid}`);
        },
        // 删除退货单
        del(row) {
            let that = this;
            this.$util.elConfirm({
                content: '确定要删除该装箱单吗？',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosPost({
                            url: '/api/EntpPackingList/DeletePackingList',
                            data: {
                                Id: row.Id
                            }
                        })
                        .then(() => {
                            that.$util.successMsg('删除成功');
                            that.getTableData();
                        })
                        .catch(() => {});
                }
            });
        },
        resetSearch() {
            this.searchData = {
                EntpCusName: '',
                Code: '',
                SId: '',
                OrderCode: '',
                StartDate: '',
                EndDate: '',
                page: 1, // 当前页数
                limit: this.commonPageSize // 每页限制条数
            };
            this.searchCustom('');
        },
        // 跳转订单详情
        gotoDetails(type, item) {
            let PLId = item ? item.Id : '';
            this.$router.push(`/inventoryManage/packingList/edit?type=${type}&PLId=${PLId}`);
        },
        // 获取数据
        getTableData() {
            this.$util
                .axiosGet({
                    url: '/api/EntpPackingList/GetEnterprisePackingList',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;
                    this.tableDataLength = res.count;
                })
                .catch(() => {});
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
            let idList = [];
            for (let i = 0; i < val.length; i++) {
                idList.push(val[i].Id);
            }
            this.idList = idList;
        },
        closeDialog() {
            this.dialogVisible = false;
        },
        closePrintEngDialog() {
            this.dialogPrintEngVisible = false;
        },
        // 打印
        print() {
            if (this.idList.length != 1) {
                this.$util.warningMsg('请选择一张装箱单打印');
                return;
            }
            if (this.multipleSelection[0].State == 0) {
                this.$util.warningMsg('不能打印未提交的装箱单');
                return;
            }
            this.dialogVisible = true;
        },
        // 打印英文版
        printEng() {
            if (this.idList.length != 1) {
                this.$util.warningMsg('请选择一张装箱单打印');
                return;
            }
            if (this.multipleSelection[0].State == 0) {
                this.$util.warningMsg('不能打印未提交的装箱单');
                return;
            }
            this.dialogPrintEngVisible = true;
        },
        // 导出
        exportForm() {
            if (!this.idList[0]) {
                this.$util.warningMsg('请至少选择一条数据导出');
                return;
            }
            let PLIds = this.idList.join(',');
            this.$util.exportFile({
                url: '/api/EntpPackingList/ExportEnterpriseCustomerPackingList',
                data: {
                    PLIds: PLIds
                }
            });
        },
        exportEngForm() {
            if (!this.idList[0]) {
                this.$util.warningMsg('请至少选择一条数据导出');
                return;
            }
            let PLIds = this.idList.join(',');
            this.$util.exportFile({
                url: '/api/EntpPackingList/ExportEnterpriseCustomerPackingListEng',
                data: {
                    PLIds: PLIds
                }
            });
        },
        //当业务员下拉框出现时触发
        siVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.SIdList.length <= 1) that.getSIdList();
            }
        },
        handleDBClick(event) {
            if (event) {
                this.gotoDetails(1, event);
            }
        }
    }
};
</script>
<style lang="less" scoped>
.ordercodediv {
    display: flex;
    flex-direction: column;
    .codetag {
        font-size: 14px;
        border-style: none none none none;
        background-color: transparent;
        padding: 0;
    }
}
</style>
<style lang="less">
.pack-order {
    .el-table__row {
        td:nth-child(2) {
            .cell {
                overflow: visible;
            }
        }
    }
    .el-tag {
        height: 14px;
        line-height: 14px;
    }
}
</style>
